import { useMemo } from 'react';
import { ITEM_UNIT_LIST_CODE, type SettingListOption } from '@peles/shared';
import { useAppSettingLists } from './useAppSettings';
import { readSettingList } from '../components/floor-plan/settingLists';

/** The units an item line can be counted in — the office's `item_units` list. */
export function useItemUnits(): SettingListOption[] {
  const { data: lists = [] } = useAppSettingLists();
  return useMemo(() => readSettingList(lists, ITEM_UNIT_LIST_CODE), [lists]);
}

/** A unit as written in Settings, else as stored; nothing for none. */
export function unitLabel(units: readonly SettingListOption[], value: string | null): string {
  if (!value) return '';
  return units.find((u) => u.value === value)?.label ?? value;
}
